import { atom, RecoilState } from "recoil";
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const VerificationCompanyAtom: RecoilState<{vaClientId: number , company: string, applicationId: number, feedbackId: number, registrationNumber?: string | null, vatNumber?: string | null, verificationAgency?: string | null}> = atom<{vaClientId: number, company: string, applicationId: number, feedbackId: number, registrationNumber?: string | null, vatNumber?: string | null, verificationAgency?: string | null}>({
    key: 'VerificationCompanyAtom',
    default: {
        vaClientId: -1,
        company: "",
        applicationId: -1,
        feedbackId: -1,
        registrationNumber: null,
        vatNumber: null,
        verificationAgency: ""
    } as {vaClientId: number , company: string, applicationId: number, feedbackId : number, registrationNumber?: string | null, vatNumber?: string | null, verificationAgency?: string | null},
    effects_UNSTABLE : [persistAtom]
});